import React, { useMemo, useCallback } from 'react';
import { Form, Button, Loader, Input, Segment, Header } from 'semantic-ui-react';
import PaymentSourceDisplay from '../../../../external-components/payments/steps/PaymentSourceDisplay';
import styles from './EditRecurringPaymentInformation.module.scss';

const EditRecurringPaymentInformation = ({ settings, source, hasExisting, policyNumber, loading, onChangePaymentMethod, onPaymentInformationUpdate, isCredit }) => {
	const { collectZipCodeForRecurringCreditCardPayments } = settings; //collectSecurityCodeForRecurringCreditCardPayments

	const isWallet = useMemo(() => (source && source.fiserv ? !!source.fiserv.walletItemId : false), [source]);
	const wallet = useMemo(() => (isWallet ? settings.wallets.find((w) => w.walletItemId === (source.fiserv || {}).walletItemId) : null), [isWallet, settings.wallets, source.fiserv]);

	const months = useMemo(
		() =>
			Array.from(Array(13).keys())
				.slice(1)
				.map((o) => {
					return { text: o, value: o };
				}),
		[]
	);

	const years = useMemo(
		() =>
			Array.from(Array(10).keys())
				.map((o) => o + new Date().getFullYear())
				.map((o) => {
					return { text: o, value: o };
				}),
		[]
	);

	const onChange = useCallback(
		(field, value) => {
			onPaymentInformationUpdate({ ...source, [field]: value });
		},
		[onPaymentInformationUpdate, source]
	);

	return (
		<div>
			{loading && <Loader inline active />}
			{!loading && (
				<div>
					{hasExisting && (
						<Segment>
							<Header>Existing Payment Method</Header>
							{isWallet && <div>Wallet: {wallet.nickname}</div>}
							<PaymentSourceDisplay source={source} />
							<Button className={styles.switch} color='blue' onClick={onChangePaymentMethod}>
								Switch to Different Payment Method?
							</Button>
						</Segment>
					)}
					<Form>
						<Form.Field>
							<label>Policy Number</label>
							<div>{policyNumber}</div>
						</Form.Field>

						{!isWallet && (
							<React.Fragment>
								{isCredit && (
									<Form.Group>
										<Form.Dropdown required name='cardExpireMonth' compact selection options={months} label='Expiration Month' defaultValue={source.cardExpireMonth} onChange={(e, { value }) => onChange('cardExpireMonth', value)} />
										<Form.Dropdown required name='cardExpireYear' compact selection options={years} label='Expiration Year' defaultValue={source.cardExpireYear} onChange={(e, { value }) => onChange('cardExpireYear', value)} />
									</Form.Group>
								)}
								{/* 
									{isCredit && collectSecurityCodeForRecurringCreditCardPayments && (
										<Form.Field required>
											<label>Security Code</label>
											<Input value={source.securityCode || ''} onChange={(e, { value }) => onChange('securityCode', value)} type='password' />
										</Form.Field>
									)} 
								*/}

								{isCredit && collectZipCodeForRecurringCreditCardPayments && (
									<Form.Field required>
										<label>Zip Code</label>
										<Input value={source.zipCode || ''} onChange={(e, { value }) => onChange('zipCode', value)} type="number" />
									</Form.Field>
								)}
								{isCredit && (
									<Form.Field required>
										<label>Email Address</label>
										<Input value={source.emailAddress} onChange={(e, { value }) => onChange('emailAddress', value)} type="email" />
									</Form.Field>
								)}
							</React.Fragment>
						)}
					</Form>
				</div>
			)}
		</div>
	);
};

export default EditRecurringPaymentInformation;
